import React from 'react';
import { useSelector } from 'react-redux';
import { Card, CardBody, Table } from 'reactstrap';
import withLoader from 'components/organisms/withLoader';
import ClinicRow from './components/clinicRow';
import ClinicsToolbar from './components/toolbar';
import ClinicsHeader from './components/header';
import ClinicsFooter from './components/footer';

const AdminPanelClinics = () => {
  const clinics = useSelector((state) => state.adminPanelClinics);
  const { getClinics: loading } = useSelector(
    (state) => state.loading.effects.adminPanelClinics,
  );
  return (
    <div className="adminPanel">
      <Card className="card-border">
        <CardBody className="card-outer">
          <ClinicsHeader />
          <ClinicsToolbar />
          <div className="adminPanel__table">
            {withLoader(
              loading,
              <Table bordered cellSpacing="0">
                <thead>
                  <tr>
                    <th>
                      <div className="adminPanel__row">Clinic</div>
                    </th>
                    <th>
                      <div className="adminPanel__row ">Home Health Agency</div>
                    </th>
                    <th>
                      <div className="adminPanel__row ">Email</div>
                    </th>
                    <th>
                      <div className="adminPanel__row ">Address</div>
                    </th>
                    <th>
                      <div className="adminPanel__row adminPanel__row--sortng">
                        Status
                      </div>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {clinics.data &&
                    clinics.data?.map((clinicRow, index) => (
                      <ClinicRow
                        key={`${clinicRow?.id}-${index}`}
                        data={clinicRow}
                      />
                    ))}
                </tbody>
              </Table>,
            )}
          </div>
          <ClinicsFooter />
        </CardBody>
      </Card>
    </div>
  );
};

export default AdminPanelClinics;
